import React, { useEffect, useState } from "react"
import Button from "../../../shared/components/atoms/button/button"
import imgOp from "../../../assets/images/performance/img-opinion.webp"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import StandardModal from "../../../shared/components/modals/standard-modal/standard-modal"
import ProductService from "../../../shared/services/product"
import { siteUrl } from "../../../shared/utils/siteUrl"
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'
import "./comments-product.scss"

const CommentsProduct = props => {
  const {
    setModalActive,
    summaryResponse,
    setisLastPage,
    setsummaryResponse,
    handleLoadSummary,
    idProduct,
    isLastPage,
    productName
  } = props

  const [activeSlide, setActiveSlide] = useState(0) // Qualify = 1, Opinion = 2, Home = 0
  const [commented, setCommented] = useState(false)

  const [textareaValue, settextareaValue] = useState("")
  const [currentValue, setCurrentValue] = useState(0)
  const [currentOpinion, setCurrentOpinion] = useState(0)

  const [disableButtonQ, setdisableButtonQ] = useState(false)
  const [disableButtonO, setdisableButtonO] = useState(false)

  useEffect(() => {
    validateQualify()
  }, [])

  const validateQualify = () => {
    if (localStorage.getItem("TOKEN_INFO") !== null) {
      localStorage.removeItem("LIST_QUALIFY")
      var config = {
        headers: {
          Authorization: JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken,
        },
      }

      ProductService.summaryProductsAuth(idProduct, 1, 0, config)
        .then(res => {
          if (res.status === 200) {
            setCurrentValue(res.data.userScore)
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    } else {
      if (localStorage.getItem("LIST_QUALIFY") !== null) {
        var copyList = JSON.parse(localStorage.getItem("LIST_QUALIFY"))
        var listFiltered = copyList.filter(
          productCopy => productCopy.productId === idProduct
        )
        var AnomQualify =
          listFiltered.length === 0
            ? 0
            : listFiltered[listFiltered.length - 1].score
        setCurrentValue(AnomQualify)
      }
    }
  }

  const handleQualify = () => {
    var payload = {
      productId: idProduct,
      score: currentValue,
      country: process.env.COUNTRY_CODE,
    }

    if (localStorage.getItem("TOKEN_INFO") !== null) {
      setdisableButtonQ(true)

      var config = {
        headers: {
          Authorization: JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken,
        },
      }

      ProductService.qualifyProduct(payload, config)
        .then(res => {
          setdisableButtonQ(false)
          if (res.status === 200) {
            pushDataLayerEvent({
              event: "review",
              action_type: "Submit a review",
              single_item_id: idProduct,
              single_item_name: productName
            })
            setActiveSlide(0)
            setModalActive(
              <StandardModal
                click={() => setModalActive(null)}
                clickButton={() => handleChangeSlideToOpinion()}
                title="¡Gracias por tu calificación!"
                subtitle=""
                description={
                  commented
                    ? "Con ella nos ayudas a que más mujeres conozcan lo que piensa nuestra comunidad sobre nuestros productos. "
                    : "Con ella nos ayudas a que más mujeres conozcan lo que piensa nuestra comunidad sobre nuestros productos. También puedes opinar sobre nuestro Producto, dejando tu comentario."
                }
                button_title={commented ? "¡Listo!" : "¡Quiero opinar!"}
              />
            )
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    } else {
      setdisableButtonQ(true)

      ProductService.qualifyProductNoAuth(payload)
        .then(res => {
          setdisableButtonQ(false)
          if (res.status === 200) {
            pushDataLayerEvent({
              event: "review",
              action_type: "Submit a review",
              single_item_id: idProduct,
              single_item_name: productName
            })
            var dispatch = [payload]

            if (localStorage.getItem("LIST_QUALIFY") === null) {
              localStorage.setItem("LIST_QUALIFY", JSON.stringify(dispatch))
            } else {
              var copyList = JSON.parse(localStorage.getItem("LIST_QUALIFY"))
              var newList = copyList.concat(dispatch)
              localStorage.setItem("LIST_QUALIFY", JSON.stringify(newList))
            }

            setActiveSlide(0)
            setModalActive(
              <StandardModal
                click={() => setModalActive(null)}
                clickButton={() => handleChangeSlideToOpinion()}
                title="¡Gracias por tu calificación!"
                subtitle=""
                description={
                  commented
                    ? "Con ella nos ayudas a que más mujeres conozcan lo que piensa nuestra comunidad sobre nuestros productos. "
                    : "Con ella nos ayudas a que más mujeres conozcan lo que piensa nuestra comunidad sobre nuestros productos. También puedes opinar sobre nuestro Producto, dejando tu comentario."
                }
                button_title={commented ? "¡Listo!" : "¡Quiero opinar!"}
              />
            )
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    }
  }

  const handleOpinion = () => {
    if (localStorage.getItem("TOKEN_INFO") !== null) {
      setdisableButtonO(true)

      var payload = {
        productId: idProduct,
        review: textareaValue,
        recommended: currentOpinion === 1 ? true : false,
        country: process.env.COUNTRY_CODE,
      }

      var config = {
        headers: {
          Authorization: JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken,
        },
      }

      ProductService.commentProduct(payload, config)
        .then(res => {
          setdisableButtonO(false)
          settextareaValue("")
          if (res.status === 200) {
            setActiveSlide(0)

            ProductService.summaryProducts(idProduct, 3, 0)
              .then(res => {
                setsummaryResponse(res.data)
                if (res.metadata.limit === res.metadata.currentPage + 1) {
                  setisLastPage(true)
                }
              })
              .catch(e => console.log(e))

            setModalActive(
              <StandardModal
                click={() => setModalActive(null)}
                clickButton={() => handleChangeSlideToQualify()}
                title="¡Gracias por tu comentario!"
                subtitle=""
                description={
                  commented
                    ? "Para Nosotras es muy importante saber lo que piensas."
                    : "Para Nosotras es muy importante saber lo que piensas. También puedes calificar nuestro Producto, dejando un corazón si te encantaron."
                }
                button_title={commented ? "¡Listo!" : "¡Quiero calificarlo!"}
              />
            )
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    } else {
      sessionStorage.setItem(
        "NEXT_PAGE",
        window.location.pathname + "#f-comment-product-section"
      )
      window.location.href = siteUrl + "/login"
    }
  }

  const handleChangeSlideToQualify = () => {
    if (!commented) {
      //Validate if user commented before
      setActiveSlide(1)
      setModalActive(null)
      setCommented(true)
    } else {
      setActiveSlide(0)
      setModalActive(null)
    }
  }

  const handleChangeSlideToOpinion = () => {
    //Validate if user commented before
    if (!commented) {
      setActiveSlide(2)
      setModalActive(null)
      setCommented(true)
    } else {
      setActiveSlide(0)
      setModalActive(null)
    }
  }

  const handleOnBlurTextarea = () => {
    if (localStorage.getItem("TOKEN_INFO") === null) {
      sessionStorage.setItem(
        "NEXT_PAGE",
        window.location.pathname + "#f-comment-product-section"
      )
      window.location.href = siteUrl + "/login/"
    }
  }

  const handleAddCommentary = () => {
    if (localStorage.getItem("TOKEN_INFO") === null) {
      sessionStorage.setItem("NEXT_PAGE", window.location.pathname)
      window.location.href = siteUrl + "/login/"
    } else setActiveSlide(2)
  }

  const myOpinion = (
    <>
      <span className="f-fake-element"></span>
      <div className="f-title-back-container">
        <span
          className="f-icon icon-izquierda"
          onClick={() => setActiveSlide(0)}
        />
        <label className="f-comment-main-title">
          <span className="f-sub-element">¿Lo </span> recomendarías?
        </label>
      </div>
      <div className="f-comment-group-container">
        <div className="f-recommend-group">
          <div
            className={
              "f-recommend-button " + (currentOpinion === 1 ? "active" : "")
            }
            onClick={() => setCurrentOpinion(1)}
          >
            <span className="f-button-title">SI</span>
            <span className="f-icon icon-like" />
          </div>
          <div
            className={
              "f-recommend-button " + (currentOpinion === 2 ? "active" : "")
            }
            onClick={() => setCurrentOpinion(2)}
          >
            <span className="f-button-title">NO</span>
            <span className="f-icon icon-dislike" />
          </div>
        </div>
        <div className="f-opinion-input-group">
          <textarea
            className="f-textarea-opinion"
            onFocus={() => handleOnBlurTextarea()}
            maxLength="500"
            onChange={e =>
              settextareaValue(e.target.value.replace(/ {2}/g, " "))
            }
            value={textareaValue}
          ></textarea>
        </div>
        <div className="f-buttons-container">
          {(textareaValue.length < 2 ||
            currentOpinion === 0 ||
            disableButtonO) && <span className="f-disable-mask" />}
          <div
            className="f-alter-button f-alter-button-opinion"
            onClick={() => handleOpinion()}
          >
            Opinar
          </div>
        </div>
      </div>
    </>
  )

  const wantQualify = (
    <>
      <span className="f-fake-element"></span>
      <div className="f-title-back-container">
        <span
          className="f-icon icon-izquierda"
          onClick={() => setActiveSlide(0)}
        />
        <label className="f-comment-main-title">
          <span className="f-sub-element">¿Quieres </span> calificarlo?
        </label>
      </div>
      <p className="f-comment-main-description">
        Puedes hacerlo de 1 a 5, no olvides que 1 es la calificación más baja y
        5 la más alta.
      </p>
      <div className="f-likes-group-container">
        <div className="f-likes-container">
          <div className="f-like-box" onClick={() => setCurrentValue(1)}>
            <span
              className={
                "f-icon " +
                (currentValue >= 1
                  ? "icon2-corazon-relleno1 small"
                  : "icon-heart-1")
              }
            />
          </div>
          <div className="f-like-box" onClick={() => setCurrentValue(2)}>
            <span
              className={
                "f-icon " +
                (currentValue >= 2
                  ? "icon2-corazon-relleno1 small"
                  : "icon-heart-1")
              }
            />
          </div>
          <div className="f-like-box" onClick={() => setCurrentValue(3)}>
            <span
              className={
                "f-icon " +
                (currentValue >= 3
                  ? "icon2-corazon-relleno1 small"
                  : "icon-heart-1")
              }
            />
          </div>
          <div className="f-like-box" onClick={() => setCurrentValue(4)}>
            <span
              className={
                "f-icon " +
                (currentValue >= 4
                  ? "icon2-corazon-relleno1 small"
                  : "icon-heart-1")
              }
            />
          </div>
          <div className="f-like-box" onClick={() => setCurrentValue(5)}>
            <span
              className={
                "f-icon " +
                (currentValue >= 5
                  ? "icon2-corazon-relleno1 small"
                  : "icon-heart-1")
              }
            />
          </div>
        </div>

        <div className="f-alter-button" onClick={() => handleQualify()}>
          Enviar calificación
        </div>
      </div>
    </>
  )

  const mainSlide = (
    <>
      <span className="f-fake-element"></span>
      <label className="f-comment-main-title">
        <span className="f-sub-element">
          ¡
          {process.env.LOCALE === "es-PY" ||
          process.env.LOCALE === "es-AR" ||
          process.env.LOCALE === "es-UY"
            ? "Contanos"
            : "Cuéntanos"}{" "}
        </span>{" "}
        sobre tu experiencia!
      </label>
      <p className="f-comment-main-description">
        Ahora{" "}
        {process.env.LOCALE === "es-PY" ||
        process.env.LOCALE === "es-AR" ||
        process.env.LOCALE === "es-UY"
          ? "podés"
          : "puedes"}{" "}
        dejarnos un corazón si te encantó, o contarnos tu opinión.{" "}
        {process.env.LOCALE === "es-PY" ||
        process.env.LOCALE === "es-AR" ||
        process.env.LOCALE === "es-UY"
          ? "¿Te animás?"
          : "¿Te animas?"}
      </p>
      <div className="f-buttons-container">
        <div className="f-alter-button" onClick={() => setActiveSlide(1)}>
          <span className="f-icon icon-heart-1" />
          Quiero calificarlo
        </div>
        <div className="f-alter-button" onClick={() => handleAddCommentary()}>
          <span className="f-icon icon-like" />
          Hacer un comentario
        </div>
      </div>
    </>
  )

  return (
    <div className="f-comment-product-section">
      <div
        className={
          "f-comment-product-section-container " +
          (activeSlide === 2 ? "f-opinion" : "")
        }
        id="f-comment-product-section"
      >
        <div className="f-likes-container">
          <img
            className="f-img-comment"
            src={imgOp}
            alt="Imagen de comentarios"
          />
          <div className="f-content-comment">
            <div className="f-comment-info-container">
              <div className="f-comment-info-position">
                {activeSlide === 0 && mainSlide}
                {activeSlide === 1 && wantQualify}
                {activeSlide === 2 && myOpinion}
              </div>
            </div>
          </div>

          <div className="f-qualify-results">
            <div className="f-qualify-results-content">
              <div className="f-qualify-element">
                <span className="f-icon icon-like" />
                <span className="f-qualify-element__value">
                  {summaryResponse && summaryResponse.recommendations}
                </span>
                <span className="f-qualify-element__text">
                  Usuarias recomiendan <br /> este producto
                </span>
              </div>

              <div className="f-qualify-element">
                <span className="f-icon icon-heart-1" />
                <span className="f-qualify-element__value">
                  {summaryResponse && summaryResponse.averageScore}
                </span>
                <span className="f-qualify-element__text">
                  Calificación promedio <br /> de este producto{" "}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {summaryResponse && (
        <div className="f-comments-list-section">
          {summaryResponse.opinions.length !== 0 && (
            <>
              <TitleTab
                title="Ellas opinan"
                className="f-TitleTab-pink f-TitleTab"
              />

              <div className="f-comments-list-container">
                {summaryResponse.opinions.map((comment, index) => {
                  return (
                    <div className="f-comment-container" key={index}>
                      <img
                        className="f-profile-photo-comment"
                        src={comment.profileImage}
                        alt="Foto de perfil comentario"
                      />
                      <div className="f-user-info-container">
                        <label className="f-user-fullname">
                          {comment.user}
                        </label>
                        <p className="f-user-comment">
                          {comment.opinionDetail}
                        </p>
                      </div>
                    </div>
                  )
                })}
                {!isLastPage &&
                  summaryResponse !== null &&
                  summaryResponse.opinions.length !== 0 && (
                    <div className="f-load-more">
                      <Button
                        className="new-dark-blue"
                        onClick={() => handleLoadSummary()}
                        title="  Cargar más"
                      />
                    </div>
                  )}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default CommentsProduct
